import { CorpoCube } from "../functions/corpo.model";
import { FormatType } from "../functions/enumType";

declare global {
    interface Window {
        pendingFormats: Map<string, CorpoCube & { format: FormatType }>;
    }
}

if (!window.pendingFormats) {
    window.pendingFormats = new Map();
}

export const pendingFormats = window.pendingFormats;